import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { AuthService } from './auth.service';
import {BehaviorSubject, from, lastValueFrom, Observable} from 'rxjs';
import { environment } from "src/environments/environment";
import { HelperService } from "./helper.service";
import { ManagementService } from "./services/management.service";
import { Role } from "./models/role";
import { Tenant } from "./models/tenant";
import { Router } from "@angular/router";
@Injectable()
export class HttpRequestInterceptor implements HttpInterceptor {

   public tenantsSubject = new BehaviorSubject<Tenant[]>(null);
  tenants$ = this.tenantsSubject.asObservable();

  public rolesSubject = new BehaviorSubject<Role[]>(null);
  roles$ = this.rolesSubject.asObservable();

  constructor(private auth: AuthService, private helper: HelperService, public managementService: ManagementService, public router: Router) {}

  // Add the bearer token to each request made to authenticate to the precisiion gateway apis
  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    return from(this.handle(req, next));
  }

  async handle(req: HttpRequest<any>, next: HttpHandler) {
    
    // Set default headers for each request.
    var modifiedRequest = null;
    // Test if the url is specified as an allowed auth header then add the Authorization header with Bearer Token.
    if (environment.allowedAuthHeaders.some(x => req.url.toString().includes(x))) {
      if (await this.auth.isLoggedIn()) {

        let token = await this.auth.getCurrentSession();

        if(token?.tokens?.accessToken) {
          // Use ID token for report endpoints (requires email claim)
          const bearerToken = req.url.toString().includes("/report") && token.tokens.idToken
            ? token.tokens.idToken.toString()
            : token.tokens.accessToken.toString();
          if (environment.allowedCustomHeaders.some(x => req.url.toString().includes(x))) {
            // AWS Lambda has issues with custom headers, thus only spring endpoints will receive the custom headers
            if(this.helper.isRepresentative(req?.url?.toString())){
              modifiedRequest = req.clone({
                headers: req.headers
                    .set('Authorization', `Bearer ${bearerToken}`)
                    .set('X-Application-User-Id', String(this.helper.getRepresentativeId()))
              });
            } else{
              modifiedRequest = req.clone({
                headers: req.headers
                    .set('Authorization', `Bearer ${bearerToken}`)
                    .set('X-Application-User-Id', String(this.helper.getUserId()))
                    // .set('Content-Type',req.headers.has('Content-Type') ? req.headers.get('Content-Type') : 'application/json')
              });
            }
          } else {
            // By default all urls should contain the access_token
            modifiedRequest = req.clone({
              headers: req.headers
                  .set('Authorization', `Bearer ${bearerToken}`)
                  .set('Content-Type',req.headers.has('Content-Type') ? req.headers.get('Content-Type') : 'application/json')
            });
          }
        }
      }  else {
        modifiedRequest = req.clone({
          headers: req.headers
              .set('Content-Type',req.headers.has('Content-Type') ? req.headers.get('Content-Type') : 'application/json')
        });
      }
    } else {
      modifiedRequest = req.clone({
        headers: req.headers
        // .set('Content-Type',req.headers.has('Content-Type') ? req.headers.get('Content-Type') : 'application/json')
      });
    }

    // return next.handle(modifiedRequest).toPromise();
    return lastValueFrom(next.handle(modifiedRequest));
  }
}
